// Renuv theme global JS — vanilla, no dependencies.

// Mobile menu drawer
const resetSubpanels = () => {
  document.querySelectorAll('.menu-drawer__subpanel.is-open').forEach((p) => p.classList.remove('is-open'));
  const panels = document.querySelector('[data-menu-panels]');
  if (panels) panels.style.minHeight = '';
};

document.querySelectorAll('[data-menu-toggle]').forEach((btn) => {
  btn.addEventListener('click', () => {
    const drawer = document.getElementById('MenuDrawer');
    if (!drawer) return;
    const open = drawer.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open);
    document.body.style.overflow = open ? 'hidden' : '';
    if (!open) resetSubpanels();
    if (open) {
      const first = drawer.querySelector('input, a, button');
      if (first) first.focus();
    } else {
      btn.focus();
    }
  });
});

// Drill-down submenu panels: slide in from the right, slide back out.
document.addEventListener('click', (e) => {
  const opener = e.target.closest('[data-submenu-open]');
  if (opener) {
    const panel = document.querySelector(`[data-subpanel="${opener.dataset.submenuOpen}"]`);
    if (panel) {
      panel.classList.add('is-open');
      const panels = panel.closest('[data-menu-panels]');
      if (panels) panels.style.minHeight = panel.scrollHeight + 'px';
      const back = panel.querySelector('[data-submenu-back]');
      if (back) back.focus();
    }
    return;
  }
  const back = e.target.closest('[data-submenu-back]');
  if (back) {
    const panel = back.closest('.menu-drawer__subpanel');
    panel.classList.remove('is-open');
    const panels = panel.closest('[data-menu-panels]');
    if (panels) panels.style.minHeight = '';
    const opener2 = document.querySelector(`[data-submenu-open="${panel.dataset.subpanel}"]`);
    if (opener2) opener2.focus();
  }
});

document.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape') return;
  const drawer = document.getElementById('MenuDrawer');
  if (drawer && drawer.classList.contains('is-open')) {
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    const btn = document.querySelector('[data-menu-toggle]');
    if (btn) {
      btn.setAttribute('aria-expanded', 'false');
      btn.focus();
    }
  }
});

// Announcement bar rotation.
// WCAG 2.2.2 (Pause, Stop, Hide): auto-updating content needs a way to stop it.
// Rotation is skipped entirely for prefers-reduced-motion, and pauses while the
// bar is hovered or contains keyboard focus so a reader can finish the message.
(() => {
  const bar = document.querySelector('[data-announcements]');
  if (!bar) return;
  const items = bar.querySelectorAll('[data-announcement]');
  if (items.length < 2) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  let i = 0;
  let paused = false;
  const advance = () => {
    if (paused) return;
    items[i].hidden = true;
    i = (i + 1) % items.length;
    items[i].hidden = false;
  };
  setInterval(advance, 4500);

  const hold = () => (paused = true);
  const release = () => (paused = false);
  bar.addEventListener('mouseenter', hold);
  bar.addEventListener('mouseleave', release);
  bar.addEventListener('focusin', hold);
  bar.addEventListener('focusout', release);
})();

// AJAX add-to-cart: all product forms add without a page reload, then the cart drawer opens.
document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const original = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled = true;
    try {
      const res = await fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        body: new FormData(form),
      });
      if (!res.ok) throw new Error('add failed');
      btn.textContent = original;
      if (window.RenuvCart) {
        try {
          const added = await res.json();
          const handle = (added.items && added.items[0] ? added.items[0].handle : added.handle) || '';
          if (handle && window.RenuvCart.setLastAdded) await window.RenuvCart.setLastAdded(handle);
        } catch (e) {
          /* pin is cosmetic; never block the add */
        }
        await window.RenuvCart.refresh();
        // Pass the button explicitly: it was disabled above, so focus has already
        // moved to <body> and the drawer would have nothing to return to on close.
        window.RenuvCart.open(btn);
      }
    } catch {
      btn.textContent = 'Try again';
      setTimeout(() => (btn.textContent = original), 2000);
    } finally {
      btn.disabled = false;
    }
  });
});

// a11y-vendor-patch: three third-party/platform sources emit controls and images
// that fail WCAG, and none of them are editable in Liquid. Patch as they appear.
//   - Judge.me injects review photos with no alt (1.1.1)
//   - Shopify's own video_tag filter emits a poster <img> fallback with no alt (1.1.1)
//   - Klaviyo's floating teaser is a role="button" whose only content is a CSS
//     background image, so its accessible name is a zero-width space (4.1.2).
//     Its own close button is labelled; the trigger is not.
(function () {
  var nameOf = function (el) {
    return (el.getAttribute('aria-label') || el.textContent || '').replace(/[\s​-‍﻿]/g, '');
  };
  var patch = function () {
    document.querySelectorAll('.jdgm-widget img:not([alt])').forEach(function (img) {
      img.setAttribute('alt', 'Customer review photo');
    });
    document.querySelectorAll('video > img:not([alt])').forEach(function (img) {
      var video = img.closest('video');
      img.setAttribute('alt', video.getAttribute('aria-label') || 'Product video preview');
    });
    document.querySelectorAll('[class*="kl-teaser"] [role="button"], [class*="kl-teaser"][role="button"]').forEach(function (el) {
      // Skip the close control, which Klaviyo already labels.
      if (nameOf(el).toLowerCase().indexOf('close') !== -1) return;
      if (!el.getAttribute('aria-label')) el.setAttribute('aria-label', 'Open email signup offer');
    });
  };
  new MutationObserver(patch).observe(document.documentElement, { subtree: true, childList: true });
  patch();
})();
